// extracted by mini-css-extract-plugin
export default {"container":"Error-container___WGkCq","container_static-position":"Error-container_static-position___ZIQ1S"};